import { render, staticRenderFns } from "./RegisterKodeAkses.vue?vue&type=template&id=58dc7508&scoped=true&"
import script from "./RegisterKodeAkses.vue?vue&type=script&lang=js&"
export * from "./RegisterKodeAkses.vue?vue&type=script&lang=js&"
import style0 from "./RegisterKodeAkses.vue?vue&type=style&index=0&id=58dc7508&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58dc7508",
  null
  
)

export default component.exports